<mat-card class="mb-2 item-card" [ngClass]="{ 'cursor-pointer': !isDataLoading }" (click)="onCardClick($event)">
  <mat-card-header class="mb-2">
    <div class="min-w-0">
      <mat-card-title class="p-0 mb-1 f-16 text-wrap">{{ item().name }}</mat-card-title>
      <mat-card-subtitle class="p-0 f-12"
        >{{ item().key }}
        <span>.</span>
        {{ item().boardName }}
      </mat-card-subtitle>
    </div>

    @if (item().status) {
      <app-inline-item-status-chip
        class="position-absolute r-7"
        [itemId]="item().id"
        [boardItemConfigurationId]="item().boardItemConfigurationId"
        [currentWorkflowStepId]="item().currentWorkflowStepId"
        (loadItem)="loadDatatable()"
        (click)="$event.stopPropagation()"
      >
        <app-status-category-badge
          [statusCategory]="item().status.statusCategory"
          [label]="item().status.workflowStepName"
        ></app-status-category-badge>
      </app-inline-item-status-chip>
    }
  </mat-card-header>
  <mat-card-footer *ngIf="item().dueDate || item().relatedItems.length">
    <div class="row">
      <div class="col-6 m-auto">
        @if (item().relatedItems.length) {
          <div class="show-hide-related-items-button" (click)="isRelatedItemsDisplayed.set(!isRelatedItemsDisplayed())">
            <span>{{
              (item().relatedItems.length === 1 ? 'button.showHideRelatedItem' : 'button.showHideRelatedItems')
                | translate: { action: showOrHide(), count: item().relatedItems.length }
            }}</span>
            <mat-icon class="s-icon">{{ isRelatedItemsDisplayed() ? 'expand_less' : 'expand_more' }} </mat-icon>
          </div>
        }
      </div>
      <div class="col-6 text-right w-fit-content">
        <app-inline-date-picker
          *ngIf="item().dueDate"
          [itemId]="item().id"
          [date]="item().dueDate"
          (click)="$event.stopPropagation()"
          (triggerRefresh)="loadDatatable()"
        >
          <app-due-date-chip
            [doIgnoreDueDateCalculation]="false"
            [dueDate]="{
              formatted: (item().dueDate | utcToUserFormatted) ?? '',
              original: item().dueDate ?? '',
            }"
            [strikeCount]="item().strikeCount"
          ></app-due-date-chip>
        </app-inline-date-picker>
      </div>
    </div>

    <div>
      @if (isRelatedItemsDisplayed()) {
        <div class="related-item-container min-w-0">
          @for (relatedItem of item().relatedItems; track relatedItem) {
            <mat-chip class="related-item text-wrap" (click)="relatedItemClick.emit(relatedItem.id)">
              <span class="text-grey pe-2">{{ relatedItem.key }}</span>
              <span class="name">{{ relatedItem.name }}</span>
            </mat-chip>
          }
        </div>
      }
    </div>
  </mat-card-footer>
</mat-card>
